(function () {
  'use strict';

  /* @ngdoc object
   * @name compartilhamentos
   * @description
   *
   */
  angular
    .module('usuarios', [
      'ui.router',
      'ui.bootstrap.modal',
      'flash',
      'enumModule',
      'ui.bootstrap.modal',
      'flash',
      'ui.tree',
      'perfis',
      'uoModule',
      'uoArvoreNivelModule',
      'v3gAuthenticatorModule',
      'enumModule',
      'FeatureFlagModule',
      'ConstantVfiltroModule',
      'ServiceVfiltroModule',
      'FactoryVfiltroModule',
      'alert-message',
      'VtabelaModule'
    ])
    .constant('PerfilIntegracao', 1001)
    .constant('PerfilAdminVeltec', 1)
    .constant('UsuariosMessageMap', {
      'Senha deve ter ao menos 8 dígitos, uma letra maiúscula, uma letra minúscula, um número e um caractere especial': 'passwordValidationMessageError',
      'Login deve ser um email': 'loginValidationMessageError',
      'Senha deve ter ao menos 8 dígitos, uma letra maiúscula, uma letra minúscula, um número e um caractere especial, Login deve ser um email': 'loginAndPasswordValidationMessageError',
      'Email inválido para usuários com perfil Administrador PS': 'veltecEmailValidationMessageError'
    })
    .constant('SHARED_EMAIL_THIRD_PARTY', ['grparceria.com.br', 'trimble.com', 'platformscience.com']);
}());
